import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { View, Animated } from 'react-native';
import { getLoginOnboardingWidgetStyles } from './LoginOnboardingWidgetStyles';
import { getTestId, Lottie, isValidObject } from '@airtel/air-design-system';
import { TypographyWidget } from '../typography-widget';
export var LoginOnboardingWidgetComponent = props => {
  var _a, _b, _c;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'LoginOnboardingWidget' : _props$testID,
    style = props.style,
    onboardinglottieProps = props.onboardinglottieProps,
    _props$showOnboarding = props.showOnboardingLottie,
    showOnboardingLottie = _props$showOnboarding === void 0 ? false : _props$showOnboarding,
    onboardingTitleProps = props.onboardingTitleProps,
    onboardingSubTitleProps = props.onboardingSubTitleProps,
    progressBarAnimationProps = props.progressBarAnimationProps,
    showProgressBar = props.showProgressBar,
    progressBarContainerStyle = props.progressBarContainerStyle;
  var localFileData = onboardinglottieProps === null || onboardinglottieProps === void 0 ? void 0 : onboardinglottieProps.localFileData;
  var progressBarFinalWidth = (_a = progressBarAnimationProps === null || progressBarAnimationProps === void 0 ? void 0 : progressBarAnimationProps.progressBarFinalWidth) !== null && _a !== void 0 ? _a : 200;
  var progressBarDuration = (_b = progressBarAnimationProps === null || progressBarAnimationProps === void 0 ? void 0 : progressBarAnimationProps.progressBarDuration) !== null && _b !== void 0 ? _b : 4500;
  var useNativeDriver = (_c = progressBarAnimationProps === null || progressBarAnimationProps === void 0 ? void 0 : progressBarAnimationProps.useNativeDriver) !== null && _c !== void 0 ? _c : false;
  var loginOnboardingWidgetStyles = getLoginOnboardingWidgetStyles();
  useEffect(() => {
    onAnimate(progressBarFinalWidth, progressBarDuration, useNativeDriver);
  }, []);
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [loginOnboardingWidgetStyles.mainContainerDefaultStyle, style]
  }, {
    children: [localFileData && showOnboardingLottie && _jsx(Lottie, Object.assign({
      localFileData: localFileData,
      style: loginOnboardingWidgetStyles.lottieDefaultStyle
    }, onboardinglottieProps)), isValidObject(onboardingTitleProps) && _jsx(TypographyWidget, Object.assign({
      style: loginOnboardingWidgetStyles.onboardingTitleDefaultStyle
    }, onboardingTitleProps)), isValidObject(onboardingSubTitleProps) && _jsx(TypographyWidget, Object.assign({
      style: loginOnboardingWidgetStyles.onboardingSubTitleDefaultStyle
    }, onboardingSubTitleProps)), showProgressBar && _jsx(View, Object.assign({
      style: [loginOnboardingWidgetStyles.progressBarContainerdefaultStyle, progressBarContainerStyle]
    }, {
      children: _jsx(View, Object.assign({
        style: [loginOnboardingWidgetStyles.progressBarContainer]
      }, {
        children: _jsx(Animated.View, {
          style: [loginOnboardingWidgetStyles.progressBar, {
            width: animatedWidth
          }]
        })
      }))
    }))]
  }));
};
var animatedWidth = new Animated.Value(0);
var onAnimate = (progressBarFinalWidth, progressBarDuration, useNativeDriver) => {
  Animated.timing(animatedWidth, {
    toValue: progressBarFinalWidth,
    duration: progressBarDuration,
    useNativeDriver: useNativeDriver
  }).start();
};
LoginOnboardingWidgetComponent.genericRendererKey = 'AirLoginOnboardingWidget';